<template>
  <form>
    <div class="card card-info">
      <div class="card-header with-border">
        <!--<h3 class="card-title">Fee Structures</h3>-->
        <a href="../Fee/FeeStructure" class="btn btn-sm btn-outline-secondary btn-default" type="button">Add New +</a>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <table class="table table-bordered  table-color" id="tbl">
              <thead>
                <tr>
                  <th>Batch</th>
                  <th>Program</th>
                  <th>Category</th>
                  <th style="width: 30px; text-align: center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in records">
                  <td>{{item.Session}}</td>
                  <td>{{item.Program}}</td>
                  <td>{{item.Category}}</td>

                  <td style="width: 30px; text-align: center">
                    <i class="fa fa-2x fa-edit" v-on:click="edit(item)"></i>
                    <!--<i class="fa fa-2x fa-print" v-on:click="print(item)"></i>-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
      sendEmp: Function,
      sendImg: Function,
    },
    data() {
      return {
        records: [],
      }
    },

    created: function () {
      this.pageLoad();
    },

    updated: function () {
      $('#tbl').DataTable();
    },


    methods: {
      pageLoad() {
        startReq();
        var vm = this;
        axios.post('/api/FeeApi/pageLoadFeeStructureRecord')
          .then(function (response) {
            //var table = $('#tbl').DataTable();
            //table.destroy();
            vm.records = response.data["rec"];
            endReq();
          })
      },

      print(item) {
        startReq();
        window.location.href = "../Fee/FeeStructurePrint?progID=" + item.ProgramID + '&sessID=' + item.SessionID + '&catID=' + item.CategoryID, '_blank';
        endReq();
      },

      edit(item) {
        startReq();
        var vm = this;
        axios.post('/api/FeeApi/editFeeStructure?progID=' + item.ProgramID + '&sessID=' + item.SessionID + '&catID=' + item.CategoryID)
          .then(function (res) {
            endReq();
            window.location.href = "../Fee/FeeStructure";
          });
      },

      cancel() {
        window.location.href = "../Fee/FeeStructureRecord";
      },
    }
  })
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/fee/feestructurerecord.vue